import React from "react";

const Contents = ({ children }) => {
    return (
        <main id="main" role="main">
            {children}
        </main>
    );
};

export default Contents;
